module.exports = __webpack_public_path__ + "h5/img/banner.b4f584ef.jpg";